export default "__VITE_ASSET__CKWPs$LQ__"